// var DOMINIO = 'http://localhost:9000'
var DOMINIO = 'https://piller.binconsultoria.com.br/api_piller'
// var DOMINIO = 'https://piller.binconsultoria.com.br/api_desenv_piller'

export const C = {
  URL: {
    AUTENTICAR: DOMINIO + '/login/',
    AUTENTICAR_ADMINISTRACAO: DOMINIO + '/login/administracao/',
    TROCAR_SENHA: DOMINIO + '/trocar_senha/',
    METAS: {
      MES_CORRENTE: DOMINIO + '/meta/mes_corrente/',
      CARREGAR_META: DOMINIO + '/meta/carregar_meta/'
    },
    CLIENTE: {
      BASE: DOMINIO + '/cliente/',
      DESBLOQUEADOS: DOMINIO + '/cliente/desbloqueados/'
    },
    INATIVO: {
      BASE: DOMINIO + '/inativo/'
    },
    PROSPECT: {
      BASE: DOMINIO + '/prospect/'
    },
    PRODUTO: {
      BASE: DOMINIO + '/produto/',
      RANKING: DOMINIO + '/produto/ranking_mais_vendidos/',
      LISTAR_CATEGORIA: DOMINIO + '/produto/listar_categoria/',
      LISTAR_POR_CATEGORIA: DOMINIO + '/produto/categoria/'
    },
    PEDIDO: {
      BASE: DOMINIO + '/pedido/',
      LISTA_FILTRADA: DOMINIO + '/pedido/origem/',
      MES_CORRENTE: DOMINIO + '/pedido/mes_corrente/origem/',
      GRUPO_PRECO: DOMINIO + '/pedido/grupo_preco/cadastrar/'
    },
    ORCAMENTO: {
      BASE: DOMINIO + '/orcamento/',
      PROSPECT: DOMINIO + '/orcamento/prospect/',
      CLIENTE: DOMINIO + '/orcamento/cliente/',
      CONVERTER_ORCAMENTO: DOMINIO + '/orcamento/converter/',
      INATIVO: DOMINIO + '/orcamento/inativo/',
      PROSPECTEDIT: {
        UPDATE: DOMINIO + '/orcamento/prospect-edit/',
        CONVERTER: DOMINIO + '/orcamento/enviar-prospect/'
      }
    },
    NOTA_FISCAL: {
      BASE: DOMINIO + '/notas/',
      NOTA_POR_PEDIDO: DOMINIO + '/notas/notas_por_pedido/'
    },
    TRANSPORTADORA: {
      BASE: DOMINIO + '/transportadora'
    },
    TABELA_PRECO: {
      BASE: DOMINIO + '/tabela_preco/',
      DISPONIVEIS: DOMINIO + '/tabela_preco/disponiveis/',
      GRUPOS: DOMINIO + '/tabela_preco/grupos/',
      GRUPO_PRECO: DOMINIO + '/tabela_preco/grupo_preco/'
    },
    CONDICAO_PAGAMENTO: {
      BASE: DOMINIO + '/condicao_pagamento/',
      CONDICAO_POR_VALOR: DOMINIO + '/condicao_pagamento/condicao_por_valor/'
    },
    COMISSAO: {
      SINTETICA: DOMINIO + '/comissao/sintetica/',
      ANALITICA: DOMINIO + '/comissao/analitica/',
      RECEBER: DOMINIO + '/comissao/receber/',
      PREVISTA: DOMINIO + '/comissao/prevista/'
    },
    GRUPO_DESCONTO: DOMINIO + '/grupo_desconto/',
    TITULO: DOMINIO + '/titulo/',
    EMBALAGEM: DOMINIO + '/embalagem/',
    REGRA_COMERCIAL: DOMINIO + '/regras_comerciais/',
    PARAMETRO_PORTAL: DOMINIO + '/parametros_portal/',
    MENU_SISTEMA: DOMINIO + '/menu_sistema/',
    DOWNLOAD: {
      BASE: '/download',
      MATERIAL_APOIO: DOMINIO + '/download/material_apoio/',
      PEDIDO: DOMINIO + '/download/pedido/',
      CNPJ: DOMINIO + '/download/prospect/',
      ORCAMENTO_PROSPECT: DOMINIO + '/download/orcamento/prospect/',
      ORCAMENTO_CLIENTE_BASE: DOMINIO + '/download/orcamento/cliente/',
      ORCAMENTO_INATIVO: DOMINIO + '/download/orcamento/inativo/'
    },
    REGRA_QZZ: {
      BASE: DOMINIO + '/qzz',
      TABELA_PRECO: DOMINIO + '/qzz/tabela-preco'
    },
    REGRA_QZW: {
      BASE: DOMINIO + '/qzw',
      UF: DOMINIO + '/qzw/uf'
    }
  }
}




// WEBPACK FOOTER //
// ./src/constante.js